<template>
  <div ref="dressCodeRef" class="dresscode-container">
    <!-- Flores decorativas -->
    <img ref="flor1Ref" src="@/assets/flor1.png" alt="Flor 1" class="flor flor1" />
    <img ref="flor2Ref" src="@/assets/flor2.png" alt="Flor 2" class="flor flor2" />

    <!-- Título -->
    <h2 ref="dressCodeTitle" class="titulo">Código de Vestimenta</h2>

    <!-- Imagen formal con vestido -->
    <img ref="iconRef" src="@/assets/codigo.png" alt="Código de vestimenta" class="vestimenta-img" />

    <!-- Texto FORMAL -->
    <p ref="textRef" class="formal-text">FORMAL</p>
    <p ref="subtextRef" class="sub-text">Reservamos los colores Dorados exclusivamente para la Quinceñaera.</p>

    <!-- Línea corregida: párrafo independiente y con ref distinto -->

    <!-- Botón 
    <a ref="btnRef" href="https://pin.it/2zfAX58jv" target="_blank" rel="noopener noreferrer" class="btn-pinterest">
      Pinterest Inspiración idea
    </a>
    -->

    <!-- Fondo decorativo edificios -->
    <img ref="edificioRef" src="@/assets/estrella.avif" alt="Edificios" class="edificios-img" />
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeComponent',
  setup() {
    const dressCodeRef = ref(null)
    const dressCodeTitle = ref(null)
    const iconRef = ref(null)
    const textRef = ref(null)
    const textRef2 = ref(null)
    const subtextRef = ref(null)
    const edificioRef = ref(null)
    const btnRef = ref(null)
    const flor1Ref = ref(null)
    const flor2Ref = ref(null)

    // Timeline principal con animaciones elegantes y rápidas
    const animateMain = () => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

      tl.fromTo(
        dressCodeTitle.value,
        { opacity: 0, y: -24, filter: 'blur(6px)', letterSpacing: '0.06em' },
        { opacity: 1, y: 0, filter: 'blur(0px)', letterSpacing: '0em', duration: 0.55 }
      )
      .fromTo(
        iconRef.value,
        { opacity: 0, scale: 0.82, rotate: -6, filter: 'blur(4px)' },
        { opacity: 1, scale: 1, rotate: 0, filter: 'blur(0px)', duration: 0.5, ease: 'back.out(1.6)' },
        '>-0.15'
      )
      .fromTo(
        textRef.value,
        { opacity: 0, x: -26, filter: 'blur(4px)' },
        { opacity: 1, x: 0, filter: 'blur(0px)', duration: 0.4 },
        '>-0.05'
      )
      .fromTo(
        subtextRef.value,
        { opacity: 0, x: 26, filter: 'blur(4px)' },
        { opacity: 1, x: 0, filter: 'blur(0px)', duration: 0.4 },
        '>-0.14'
      )

      if (textRef2.value) {
        tl.fromTo(
          textRef2.value,
          { opacity: 0, y: 18, filter: 'blur(3px)' },
          { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.45 },
          '>-0.08'
        )
      }

      if (btnRef.value) {
        tl.fromTo(
          btnRef.value,
          { opacity: 0, y: 12, scale: 0.96 },
          { opacity: 1, y: 0, scale: 1, duration: 0.35 },
          '>-0.1'
        )
      }

      tl.fromTo(
        edificioRef.value,
        { opacity: 0, y: 22, filter: 'blur(3px)' },
        { opacity: 0.3, y: 0, filter: 'blur(0px)', duration: 0.5 },
        '>-0.08'
      )
    }

    const animateFlor = (el, fromX = -60) => {
      gsap.fromTo(
        el,
        { opacity: 0, x: fromX, rotate: fromX < 0 ? -6 : 6, filter: 'blur(3px)' },
        { opacity: 1, x: 0, rotate: 0, filter: 'blur(0px)', duration: 0.55, ease: 'power2.out' }
      )
    }

    onMounted(() => {
      nextTick(() => {
        // Dispara las animaciones una sola vez al entrar al viewport
        ScrollTrigger.create({
          trigger: dressCodeRef.value,
          start: 'top 86%',
          once: true,
          onEnter: animateMain
        })

        if (flor1Ref.value) {
          ScrollTrigger.create({
            trigger: flor1Ref.value,
            start: 'top 94%',
            once: true,
            onEnter: () => animateFlor(flor1Ref.value, -70)
          })
        }
        if (flor2Ref.value) {
          ScrollTrigger.create({
            trigger: flor2Ref.value,
            start: 'top 94%',
            once: true,
            onEnter: () => animateFlor(flor2Ref.value, 70)
          })
        }

        // Parallax sutil de la estrella mientras hace scroll (lujoso y discreto)
        if (edificioRef.value) {
          gsap.to(edificioRef.value, {
            yPercent: -6,
            ease: 'none',
            scrollTrigger: {
              trigger: dressCodeRef.value,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.35
            }
          })
        }
      })
    })

    return {
      dressCodeRef,
      dressCodeTitle,
      iconRef,
      textRef,
      textRef2,
      subtextRef,
      edificioRef,
      btnRef,
      flor1Ref,
      flor2Ref,
    }
  }
}
</script>

<style scoped>
.dresscode-container {
  position: relative;
  text-align: center;
  padding: 40px 0;
  z-index: 12;
  background-size: cover;
  background-position: center;
  max-width: 500px;
  margin: 0 auto;
}

.titulo {
  font-family: 'britishgruesa', cursive;
  font-size: 56px;
  color: #363636;
  margin-bottom: 30px;
  opacity: 0;
}

.vestimenta-img {
  width: 240px;
  height: auto;
  opacity: 0;
  margin-bottom: 30px;
}

.formal-text {
  font-family: 'quote', serif;
  font-size: 20px;
  color: #383636;
  opacity: 0;
  margin-bottom: 10px;
  letter-spacing: 2px;
}

.sub-text {
  font-family: 'quote', serif;
  font-size: 20px;
  color: #000;
  opacity: 0;
  margin-bottom: 30px;
}

.edificios-img {
  width: 30%;
  height: auto;
  opacity: 0;
  margin-top: -50px;
  margin-bottom: -20px;
}

.btn-pinterest {
  background-color: #070707;
  color: white;
  padding: 12px 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  border: none;
  border-radius: 25px;
  font-weight: bold;
  cursor: pointer;
  opacity: 0;
  transition: 0.3s ease;
}
.btn-pinterest:hover {
  background-color: #c36d80;
}

/* Flores */
.flor {
  position: absolute;
  opacity: 0;
  width: 120px;
  height: auto;
  z-index: 1;
}
.flor1 {
  top: -90px;
  left: -10px;
}
.flor2 {
  top: 10px;
  right: -20px;
}
</style>
